const API_URL = process.env.REACT_APP_API_URL;

class AuthService {
  async login(email, password) {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: email,
          password: password
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Identifiants invalides');
        }
        throw new Error(data.message || 'Erreur lors de la connexion');
      }

      if (data.token) {
        localStorage.setItem('token', data.token);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('token');
  }

  getCurrentToken() {
    return localStorage.getItem('token');
  }

  isAuthenticated() {
    const token = this.getCurrentToken();
    return !!token; // Retourne true si le token existe
  }
}

export default new AuthService(); 